export enum FileTypes {
  OCR = "OCR",
  LINDOFF = "Lindoff",
}
